import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { images } from '../../data/images';
export function StoresCta() {
  return <section aria-labelledby="stores-title" className="w-full bg-cream pb-24 md:pb-32" data-id="element-94" data-mp="2s62443alnj5b">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-95" data-mp="2n78zz1h7d4ht">
        <div className="grid overflow-hidden rounded-[2rem] bg-leaf lg:grid-cols-2" data-id="element-96" data-mp="2n6pfpe42y40m">
          <div className="flex flex-col justify-center p-10 md:p-16" data-id="element-97" data-mp="2j6fcuabl3tpz">
            <h2 id="stores-title" className="font-serif text-5xl leading-[1] text-aloe-900 md:text-6xl" data-id="element-98" data-mp="2eedt63c370px">
              Aloesol près de chez vous.
            </h2>
            <p className="mt-5 max-w-md text-lg text-aloe-900/80" data-id="element-99" data-mp="29dq4vpf8sxze">
              Nos cosmétiques et compléments alimentaires sont disponibles en pharmacie et parapharmacie.
            </p>
            <div className="mt-10 flex flex-wrap gap-3" data-id="element-100" data-mp="1zgv3myrl4jhf">
              <Link to="/points-de-vente" className="inline-flex items-center gap-2 rounded-full bg-aloe-900 px-7 py-4 text-sm font-semibold text-cream transition-colors duration-150 ease-out hover:bg-aloe-700" data-id="element-101" data-mp="1vft4sj1ky9fz">
                <MapPinIcon className="h-4 w-4" data-id="element-102" data-mp="12e6tnh7ysipp" />
                Voir les points de vente
              </Link>
              <Link to="/contact" className="group inline-flex items-center gap-2 rounded-full px-6 py-4 text-sm font-semibold text-aloe-900 ring-1 ring-inset ring-aloe-900/30 transition-colors duration-150 ease-out hover:bg-aloe-900/10" data-id="element-103" data-mp="smk9uwhk9bbc">
                Nous contacter
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-104" data-mp="17bzyo6xj76oe" />
              </Link>
            </div>
          </div>
          <div className="min-h-[320px] bg-sage" data-id="element-105" data-mp="3s1pa09z10acc">
            <img src={images.lifestyleTowel} alt="Gel Aloesol posé sur une serviette" className="h-full w-full object-cover" data-id="element-106" data-mp="3s0w7xmb0i90j" />
          </div>
        </div>
      </div>
    </section>;
}